import { PaymentForm } from '@models/form/form.models';
import { PaymentFlow } from '@models/payment.model';
import { N0CreditAccount } from '@models/responses/credit-file-information.model';
import { VoucherInformation } from '@models/responses/voucher-information.model';
import { createAction, props } from '@ngrx/store';
import { Payment } from 'src/app/models/booking.models';

export const enum PaymentActionTypes {
  getPaymentMethods = '[payment] GET_PAYMENT_METHODS',
  setPaymentMethods = '[payment] SET_PAYMENT_METHODS',
  submitPayments = '[payment] SUBMIT_PAYMENTS',
  submitPaymentsSuccess = '[payment] SUBMIT_PAYMENTS_SUCCESS',
  refundPaymentsSuccess = '[payment] REFUND_PAYMENTS_SUCCESS',
  // voucher
  verifyVoucher = '[payment] VOUCHER_VERIFICATION',
  voucherVerificationSuccess = '[payment] VOUCHER_VERIFICATION_SUCCESS',
  voucherVerificationFailure = '[payment] VOUCHER_VERIFICATION_FAILURE',
  applyVoucher = '[payment] APPLY_VOUCHER',
  applyVoucherSuccess = '[payment] APPLY_VOUCHER_SUCCESS',
  // credit file
  verifyCreditFile = '[payment] CREDIT_FILE_VERIFICATION',
  creditFileVerificationSuccess = '[payment] CREDIT_FILE_VERIFICATION_SUCCESS',
  creditFileVerificationFailure = '[payment] CREDIT_FILE_VERIFICATION_FAILURE',
  applyCreditFile = '[payment] APPLY_CREDIT_FILE',
  applyCreditFileSuccess = '[payment] APPLY_CREDIT_FILE_SUCCESS',
  updateMarketingOptIn = '[payment] UPDATE_MARKETING_OPT_IN',
  setUseMultiplePayments = '[payment] TOGGLE_USE_MULTIPLE_PAYMENTS',
  updateMonthlyStatus = '[payment] UPDATE_MONTHLY_STATUS',
  selectpaymentFlow = '[payment] SELECT_PAYMENT_FLOW',
  requestVCCData = '[payment] REQUEST_VCC_DATA',
  setPaymentStatusReference = '[payment] SET_PAYMENT_STATUS_REFERENCE',
  setPaymentInProgress = '[payment] SET_PAYMENT_IN_PROGRESS',
  clearPaymentFlow = '[payment] CLEAR_PAYMENT_FLOW',
  clearPaymentErrors = '[payment] CLEAR_PAYMENT_ERRORS',
}

export const setUseMultiplePayments = createAction(
  PaymentActionTypes.setUseMultiplePayments,
  props<{ value: boolean }>(),
);

export const paymentGetPaymentMethods = createAction(
  PaymentActionTypes.getPaymentMethods,
);

export const paymentSetPaymentMethods = createAction(
  PaymentActionTypes.setPaymentMethods,
  props<{ payload: Payment[] }>(),
);

export const paymentSubmitPayments = createAction(
  PaymentActionTypes.submitPayments,
  props<{
    payments: PaymentForm[];
  }>(),
);

export const clearPaymentFlow = createAction(
  PaymentActionTypes.clearPaymentFlow,
);

export const clearPaymentErrors = createAction(
  PaymentActionTypes.clearPaymentErrors,
);

export const paymentRequestVCCData = createAction(
  PaymentActionTypes.requestVCCData,
);

export const paymentSubmitPaymentsSuccess = createAction(
  PaymentActionTypes.submitPaymentsSuccess,
);

export const paymentRefundPaymentsSuccess = createAction(
  PaymentActionTypes.refundPaymentsSuccess,
);

export const paymentVoucherVerificationSuccess = createAction(
  PaymentActionTypes.voucherVerificationSuccess,
  props<{ voucherInformation: VoucherInformation }>(),
);

export const paymentVoucherVerificationFailure = createAction(
  PaymentActionTypes.voucherVerificationFailure,
  props<{ voucherCode: string }>(),
);

export const paymentVerifyVoucher = createAction(
  PaymentActionTypes.verifyVoucher,
  props<{ voucherCode: string }>(),
);

export const paymentApplyVoucher = createAction(
  PaymentActionTypes.applyVoucher,
  props<{ voucherCode: string }>(),
);

export const paymentApplyVoucherSuccess = createAction(
  PaymentActionTypes.applyVoucherSuccess,
  props<{ voucherCode: string }>(),
);

export const paymentCreditFileVerificationSuccess = createAction(
  PaymentActionTypes.creditFileVerificationSuccess,
  props<{ creditFilePnr: string; creditFileInformation: N0CreditAccount }>(),
);

export const paymentCreditFileVerificationFailure = createAction(
  PaymentActionTypes.creditFileVerificationFailure,
  props<{ creditFilePnr: string }>(),
);

export const paymentVerifyCreditFile = createAction(
  PaymentActionTypes.verifyCreditFile,
  props<{ creditFilePnr: string }>(),
);

export const paymentApplyCreditFile = createAction(
  PaymentActionTypes.applyCreditFile,
  props<{ creditFilePnr: string }>(),
);

export const paymentApplyCreditFileSuccess = createAction(
  PaymentActionTypes.applyCreditFileSuccess,
  props<{ creditFilePnr: string }>(),
);

export const paymentUpdateMarketingOptIn = createAction(
  PaymentActionTypes.updateMarketingOptIn,
  props<{ enable: boolean }>(),
);

export const paymentSelectFlow = createAction(
  PaymentActionTypes.selectpaymentFlow,
  props<{ flow: PaymentFlow | null }>()
)

export const setPaymentStatusReference = createAction(
  PaymentActionTypes.setPaymentStatusReference,
  props<{ paymentStatusReference: string}>()
)

export const setPaymentInProgress = createAction(
  PaymentActionTypes.setPaymentInProgress,
  props<{ paymentInProgress: boolean}>()
)
